import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"

export default class extends Controller {
  static values = { url: String }

  connect() {
    const initialValue = this.element.value

    this.select = new TomSelect(this.element, {
      valueField: "id",
      labelField: "text",
      searchField: "text",
      create: false,
      loadThrottle: 300,

      load: (query, callback) => {
        if (!query.length) return callback()

        const url = new URL(this.urlValue, window.location.origin)
        url.searchParams.set("q", query)

        fetch(url.toString(), { headers: { Accept: "application/json" } })
          .then((r) => r.json())
          .then((json) => callback(json.data))
          .catch(() => callback())
      }
    })

    // ✅ Sempre que o TomSelect mudar, propaga change no <select> nativo (bubbles!)
    this.select.on("change", () => this.notifyChange())

    // sincroniza valor inicial (edit) e dispara change (opcional)
    if (initialValue) {
      this.select.setValue(initialValue, true)
      // se você quer disparar o 2º nível ao abrir edição, descomente:
      // this.notifyChange()
    }
  }

  disconnect() {
    if (this.select) {
      this.select.destroy()
      this.select = null
    }
  }

  notifyChange() {
    // 🔥 o form-table-dependents está no <form> e escuta change via bubbling
    this.element.dispatchEvent(new Event("change", { bubbles: true }))
  }

  // Se você precisar setar via código:
  setValue(value) {
    if (!this.select) return
    this.select.setValue(value, true)
    this.notifyChange()
  }

  // Se você precisar inserir option manualmente:
  selectItem({ id, label }) {
    let opt = Array.from(this.element.options).find((o) => o.value === String(id))
    if (!opt) {
      opt = new Option(label, String(id), true, true)
      this.element.add(opt)
    } else {
      opt.selected = true
    }

    // Mantém TomSelect alinhado
    if (this.select) this.select.setValue(String(id), true)

    // 🔥 ESSENCIAL: dispara change para o dependent frame
    this.notifyChange()
  }
}